import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';

type Props = Pick<
  React.ComponentProps<typeof LoadingSpinner>,
  'size' | 'label' | 'inline' | 'message'
>;

const IntegrationSpinner = ({
  size = 50,
  label = 'Loading',
  inline = false,
  message = ''
}: Props) =>
  inline ? (
    <LoadingSpinner message={message} size={size} label={label} inline />
  ) : (
    <div className="grid w-full h-full">
      <div className="self-center justify-self-center integration-spinner__glyph">
        <LoadingSpinner
          message={message}
          size={size}
          label={label}
          inline
          className="inline-flex"
        />
      </div>
    </div>
  );

export default IntegrationSpinner;
